module.exports = __webpack_public_path__ + "img/carshina21_18.da899693.jpg";